import { JwtHelperService } from '@auth0/angular-jwt';
import { ROUTER_NAVIGATION } from '@ngrx/router-store';
import { ApplicationAction, ApplicationActionName, ApplicationState } from './application.state';

const auth_token = localStorage.getItem('auth_token');
const savedUser = auth_token ? new JwtHelperService({}).decodeToken(auth_token) : null;
const navExpanded = localStorage.getItem('navExpanded') === 'true';

const now = new Date().getTime().toString();
localStorage.setItem('b-gantt-trial-start', now);
localStorage.setItem('b-gantt-verify-date', now);


const initialState: ApplicationState = {
  navExpanded: navExpanded,
  token: auth_token,
  role: savedUser?.role ?? null,
  user: savedUser,
  login: null,
  socialUser: null,
  settings: {
    applicationName: 'WorkBuddy',
    applicationDescription: 'Welcome to the WorkBuddy portal',
    logo: '',
    banner: '/images/banner.jpg'
  },
  route: null,
  returnUrl: '',
  domain: '',
  info: null,
  device: null,
};

export function applicationReducer(state = initialState, action: ApplicationAction) {
  switch (action.type) {
    case ApplicationActionName.ToggleNav:
      const expanded = !state.navExpanded;
      localStorage.setItem('navExpanded', expanded ? 'true' : 'false');
      return { ...state, navExpanded: expanded };

    case ApplicationActionName.RouterNavigated:
      return { ...state, route: action.payload };

    case ApplicationActionName.LoginError:
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_refresh_token');
      return { ...state, token: null, user: null, login: action.payload };

    case ApplicationActionName.Logout:
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_refresh_token');
      return { ...state, token: null };

    case ApplicationActionName.SetDeviceInfo:
      return { ...state, device: action.payload };

    case ApplicationActionName.LoginAuthorised: {

      const token = action.payload ? action.payload.token : '';

      localStorage.setItem('auth_token', token);
      localStorage.removeItem('auth_refresh_token');

      const jwt = new JwtHelperService({});
      const user = token ? jwt.decodeToken(token) : null;

      const role = user?.role ?? null;

      return {
        ...state,
        token: token,
        domain: user ? user.domain : null,
        user: user,
        role: role,
        login: null,
        navExpanded: false,
      };
    }
    case ApplicationActionName.ActionSuccess: {
      const subAction = action.payload;
      switch (subAction.type) {
        case ApplicationActionName.GetTenantInfo: {
          const subPayload = subAction.payload;
          return { ...state, info: subPayload.info, returnUrl: subPayload.returnUrl };
        }
        case ApplicationActionName.SetGeneralSetting: {
          return { ...state, info: { ...state.info, generalSettings: subAction.payload } };
        }
        default:
          return state;
      }
    }

    case ROUTER_NAVIGATION: {
      return { ...state, route: action.payload.routerState };
    }

    default:
      return state;
  }
}
